import { useState } from "react";
import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import TaxPayer, { TaxPayerSpecialPermissions } from "../../models/tax-payer";
import TaxPayerSpecialPermissionsForm from "./TaxPayerSpecialPermissionsForm";

interface Props {
  show: boolean;
  taxPayer?: TaxPayer;
  onCancel: () => void;
  onSuccess: (permissions: TaxPayerSpecialPermissions) => void;
}

const TaxPayerSpecialPermissionsModal = ({
  show,
  taxPayer,
  onCancel,
  onSuccess,
}: Props) => {
  const [saving, setSaving] = useState(false);

  return (
    <CModal
      show={show}
      onClose={() => {
        if (!saving) onCancel();
      }}
    >
      <CModalHeader closeButton={!saving}>
        <CModalTitle>
          Permisos especiales: {taxPayer?.socialName || taxPayer?.ruc}
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        {show && taxPayer && (
          <TaxPayerSpecialPermissionsForm
            key={taxPayer.id}
            taxPayer={taxPayer}
            onCancel={onCancel}
            onSuccess={onSuccess}
            onBusyChange={setSaving}
          />
        )}
      </CModalBody>
    </CModal>
  );
};

export default TaxPayerSpecialPermissionsModal;
